export const OPREMA_V1ResourcesEN: OPREMA_V1ResourcesBSInterface = {
  errors: {
    registerPic: "The picture you are uploading is too large.",
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
  input: {
    datum: {
      name: "datum",
      label: "Task completion date",
      placeholder: "Enter date",
    },
    tip: {
      name: "tip",
      label: "Please enter type",
      placeholder: "Enter type",
    },
    izvrsioc: {
      name: "izvrsioc",
      label: "Please enter performer name",
      placeholder: "Enter performer name",
    },
    opis: {
      name: "opis",
      label: "Please enter description",
      placeholder: "Enter description",
    },
  },
  type: {
    EvdLabel: "Evidence type",
    Name: "type",
    Placeholder:
      "Enter: Regular, extraordinary, general, weekly, monthly, yearly...",
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
};

interface InputField {
  name: string;
  label: string;
  placeholder: string;
}

interface Input {
  datum: InputField;
  tip: InputField;
  izvrsioc: InputField;
  opis: InputField;
}

interface Type {
  EvdLabel: string;
  Name: string;
  Placeholder: string;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface OPREMA_V1ResourcesBSInterface {
  input: Input;
  type: Type;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: IErrors;
}
